export default __webpack_public_path__ + "static/media/codingblocks.977f1904.jpg";